<div
  class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 cursor-pointer hover-card"
>
  <div class="d-flex align-items-center">
    <ui-keenicon [name]="icon()" [class]="iconClass()"></ui-keenicon>
    <div class="fs-2 fw-bolder">{{ count() }}</div>
  </div>
  <div class="fw-bold fs-6 text-gray-400">
    {{ text() }}
  </div>
</div>
